<style lang="less" scoped>
@import "./cities-selector.less";
</style>

<template>
  <div class="cities-selector">
    <!-- 顶部导航栏 -->
    <div class="header-navi">
      <div @click="onSelectClick" class="header-navi-wrapper">
        <img class="location" src="../../assets/home/location_default.png" />
        <div>
          {{
            selectedText
              ? `${selectedText.province}，${selectedText.city}`
              : "请选择地区"
          }}
        </div>
        <img
          :class="['triangle-icon', selectorVisible ? 'triangle-down' : '']"
          src="../../assets/home/arrow.png"
        />
      </div>
      <div @click="serchNearStore" class="header-navi-wrapper">
        <img
          class="current-location"
          src="../../assets/home/location_current.png"
        />
        <span class="header-navi-wrapper-text">重新定位</span>
      </div>
    </div>

    <!-- 城市选择面板 -->
    <div
      :class="[
        'selector-panel',
        `animated faster ${
          selectorAnimateVisible ? 'fadeInDown' : 'fadeOutUp'
        }`,
      ]"
      v-if="selectorVisible"
    >
      <!-- 省市标题 -->
      <!-- <div class="selector-panel-header">
        <div class="province-head-label">省</div>
        <div class="city-head-label">市</div>
      </div> -->

      <!-- 省市选择 -->
      <div class="selector-panel-content">
        <div class="province-wrapper">
          <div
            :class="[
              'province-label',
              `${
                selectedRegion.province.name === item.name ? 'text-line' : ''
              }`,
            ]"
            :key="index"
            @click="onSelectProvinceClick(item)"
            v-for="(item, index) in regionList"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="city-wrapper">
          <div class="city-wrapper-container">
            <div
              :class="[
                'city-label',
                `${selectedRegion.city.name === item.name ? 'selected' : ''}`,
              ]"
              :key="index"
              @click="onSelectCityClick(item)"
              v-for="(item, index) in selectedRegion.province.cities"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="selector-panel-footer">
        <div @click="onCancelClick" class="footer-btn">取消</div>
        <div @click="onCertainClick" class="footer-btn black-btn">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCityList, getProvinceList, getCities } from "./_service.js";

export default {
  props: {
    // 外部传值
    currentRegion: {
      type: Object,
      default: {
        province: {},
        city: {},
      },
    },
  },
  data() {
    return {
      // 省市列表
      regionList: [],
      // 选择地区文本
      selectedText: null,
      // 默认城市
      defaultRegion: {},
      // 当前定位城市
      locationRegion: {},
      // 记录选择地区
      selectedRegion: {
        province: {
          cities: [],
        },
        city: {},
      },
      // 控制选择器显示
      selectorVisible: false,
      // 控制选择器动画显示
      selectorAnimateVisible: false,
    };
  },
  watch: {
    currentRegion: function(val) {
      this.regionList.length && this.handleDefaultSelectedRegion();
    },
  },
  mounted() {
    getProvinceList().then((regionList) => {
      this.regionList = regionList;
      this.handleDefaultSelectedRegion();
    });
  },
  methods: {
    /**
     * 事件处理
     */
    // 查找附近门店
    serchNearStore() {
      this.selectedText = null;
      this.selectedRegion = {
        province: {
          cities: [],
        },
        city: {},
      };
      this.hideSelector();
      this.$emit("on-nearStore");
    },
    onSelectClick(e) {
      this.selectorVisible ? this.hideSelector() : this.showSelector();
    },
    // 点击市选择事件
    onSelectCityClick(e) {
      this.selectedRegion.city = e;
    },
    // 点击省选择事件
    onSelectProvinceClick(province) {
      this.selectedRegion.province = province;
      if (!province.cities.length) {
        getCities(province.name).then((cityList) => {
          province.cities = cityList;
          this.selectedRegion.province.cities = province.cities;
        });
      } else {
        this.selectedRegion.province.cities = province.cities;
      }
      // this.selectedRegion.city = {};
    },
    // 点击取消事件
    onCancelClick(e) {
      this.hideSelector();
    },
    // 点击确定事件
    onCertainClick(e) {
      const { city = {}, province = {} } = this.selectedRegion;
      if (!city.name || !province.name) return;
      this.hideSelector();
      this.selectedText = {
        city: city.name,
        province: province.name,
      };
      this.$emit("on-certain", this.selectedText);
    },

    /**
     * 数据处理
     */
    // 展示选择器
    showSelector() {
      this.selectorVisible = true;
      this.selectorAnimateVisible = true;
    },
    // 隐藏选择器
    hideSelector() {
      this.selectorAnimateVisible = false;
      setTimeout(() => {
        this.selectorVisible = false;
      }, 500);
    },
    // 处理默认就选择的地区
    handleDefaultSelectedRegion(params) {
      const { province = {}, city = {} } = this.currentRegion;
      if (!province.name || !city.name) {
        return;
      }
      const selectedProvince = this.regionList.find(
        (item) => item.name === province.name
      );

      if (!selectedProvince) {
        return;
      }

      this.selectedRegion.province = selectedProvince;
      // 获取城市
      getCities(selectedProvince.name).then((cityList) => {
        this.selectedRegion.province.cities = cityList;
        const selectedCity = cityList.find((item) => item.name === city.name);
        this.selectedRegion.city = selectedCity;
        this.selectedText = {
          city: selectedCity.name,
          province: selectedProvince.name,
        };
      });
    },
  },
};
</script>
